import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { SecurityRequestService } from './security-request.service';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftGraphService {

  public PhotoDefault = "https://apmidasstorage.blob.core.windows.net/cdn/avata.jpg";

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private securityRequestService: SecurityRequestService
  ) {

  }

  private GetHeader(): Observable<any> {

    return this.authService.AcquireTokenSilentGraph().pipe(
      map(request => {
        return Object.assign({}, {
          headers: new HttpHeaders().set('Authorization', `Bearer ${request.accessToken}`)
        });
      })
    )
  }

  getCompleteProfile(email: string): Observable<any> {

    return this.GetHeader()
      .pipe(
        switchMap(headers => this.http.request('GET', `https://graph.microsoft.com/v1.0/users?$select=displayName,givenName,jobTitle,mail,mobilePhone,officeLocation,preferredLanguage,surname,eserPrincipalName,id,businessPhones&$filter=(mail eq '${email}')`, headers)),
        map(x => {
          var _contato = x['value'][0];
          return {
            Nome: _contato.displayName,
            Telefone: _contato.businessPhones == null ? '' : _contato.businessPhones[0],
            Celular: _contato.mobilePhone == null ? '' : _contato.mobilePhone,
            Email: _contato.mail
          };
        }),
        catchError((x) => {
          return of(null);
        })
      );
  }
  getCompleteProfileStartsWith(filter: string): Observable<any> {
    return this.GetHeader()
      .pipe(
        switchMap(headers => this.http.request('GET', `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName,'${filter}')`, headers)),
        map(x => x['value'])
      );
  }

  getPhoto(): Observable<any> {
    return this.securityRequestService.get(`https://graph.microsoft.com/v1.0/me/photos/48x48/$value`,
      {
        responseType: "blob"
      }).pipe(
        switchMap(res => {
          return this.readFile(res);
        }),
        catchError((e) => {
          return of(this.PhotoDefault);
        })
      );
  }

  private readFile = (blob: Blob): Observable<string> => Observable.create(obs => {
    if (!(blob instanceof Blob)) {
      return of(this.PhotoDefault);
    }

    const reader = new FileReader();

    reader.onerror = err => obs.error(err);
    reader.onabort = err => obs.error(err);
    reader.onload = () => obs.next(reader.result);
    reader.onloadend = () => obs.complete();

    return reader.readAsDataURL(blob);
  });
}
